export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10556.ee6eb75f.jpg";